const routes = {
	path: '/admin',
	component: resolve => require ( ['./../admin-views/index.vue'], resolve ),
	children: [

		// {
		// 	path: 'dashboard',
		// 	alias: '/',
		// 	component: resolve => require ( ['./../admin-views/dashboard.vue'], resolve )
		// },
		// {
		// 	path: 'signin',
		// 	component: resolve => require ( ['./../admin-views/signin.vue'], resolve )
		// },
		{
			path: 'cleaners',
			alias: '',
			component: resolve => require ( ['./../admin-views/cleaners/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Cleaners'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/cleaners/cleaners-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
				{
					path: 'new',
					component: resolve => require ( ['./../admin-views/cleaners/cleaners-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Cleaner'
					}
				},
				{
					path: ':cleanerID/update',
					component: resolve => require ( ['./../admin-views/cleaners/cleaners-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Edit Cleaner'
					}
				},
				{
					path: ':cleanerID/view',
					component: resolve => require ( ['./../admin-views/cleaners/cleaners-view.vue'], resolve ),
					meta: {
						breadcrumb: 'View Cleaner'
					}
				},
				{
					path: ':cleanerID/availability',
					component: resolve => require ( ['./../admin-views/cleaners/cleaners-availability-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Cleaner Availability'
					}
				},
				{
					path: ':cleanerID/schedule',
					component: resolve => require ( ['./../admin-views/cleaners/cleaners-schedule-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Cleaner Schedule'
					}
				},
				{
					path: 'set-unavailable-date',
					component: resolve => require ( ['./../admin-views/cleaners/unavailable-date-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Cleaner unavailable date'
					}
				}
			]
		},
		{
			path: 'reviews',
			alias: '',
			component: resolve => require ( ['./../admin-views/reviews/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Reviews'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/reviews/reviews-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},				
			]
		},
		{
			path: 'customers',
			component: resolve => require ( ['./../admin-views/customers/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Customers'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/customers/customers-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
				{
					path: 'new',
					component: resolve => require ( ['./../admin-views/customers/customers-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Customer'
					}
				},
				{
					path: ':customerID/update',
					component: resolve => require ( ['./../admin-views/customers/customers-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Edit Customer'
					}
				},
				{
					path: ':customerID/view',
					component: resolve => require ( ['./../admin-views/customers/customers-view.vue'], resolve ),
					meta: {
						breadcrumb: 'View Customer'
					}
				},
				{
					path: ':customerID/address/:action/:addressID',
					component: resolve => require ( ['./../admin-views/customers/customers-address-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Customer address'
					}
				},
				{
					path: ':customerID/address/:action',
					component: resolve => require ( ['./../admin-views/customers/customers-address-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Customer address'
					}
				}
			]
		},
		{
			path: 'packages',
			component: resolve => require ( ['./../admin-views/packages/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Packages'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/packages/packages-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
				{
					path: 'new',
					component: resolve => require ( ['./../admin-views/packages/packages-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Package'
					}
				},
				{
					path: ':packageID/update',
					component: resolve => require ( ['./../admin-views/packages/packages-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Edit Package'
					}
				},
				{
					path: ':packageID/view',
					component: resolve => require ( ['./../admin-views/packages/packages-view.vue'], resolve ),
					meta: {
						breadcrumb: 'View Package'
					}
				}
			]
		},
		{
			path: 'cms',
			component: resolve => require ( ['./../admin-views/cms/index.vue'], resolve ),
			meta: {
				breadcrumb: 'cms'
			},
			children: [
				{
					path: 'home-page',
					component: resolve => require ( ['./../admin-views/cms/home-page/index.vue'], resolve ),
					meta: {
						breadcrumb: 'Home Page'
					}
				},
				{
					path: 'our-services',
					component: resolve => require ( ['./../admin-views/cms/our-services/index.vue'], resolve ),
					meta: {
						breadcrumb: 'Our Services Page'
					}
				},
				{
					path: 'testimonial',
					component: resolve => require ( ['./../admin-views/cms/testimonial/index.vue'], resolve ),
					meta: {
						breadcrumb: 'Testimonial'
					},
					children: [
						{
							path: '',
							component: resolve => require ( ['./../admin-views/cms/testimonial/testimonial-list.vue'], resolve ),
							meta: {
								breadcrumb: 'Home'
							}
						},
						{
							path: 'new',
							component: resolve => require ( ['./../admin-views/cms/testimonial/testimonial-form.vue'], resolve ),
							meta: {
								breadcrumb: 'New'
							}
						},
						{
							path: ':testimonialID/update',
							component: resolve => require ( ['./../admin-views/cms/testimonial/testimonial-form.vue'], resolve ),
							meta: {
								breadcrumb: 'Edit Testimonial'
							}
						}
					]
				},
				{
					path: 'join-as-cleaner',
					component: resolve => require ( ['./../admin-views/cms/join-as-cleaner/index.vue'], resolve ),
					meta: {
						breadcrumb: 'Join As Cleaner'
					}
				},
				{
					path: 'contact-us',
					component: resolve => require ( ['./../admin-views/cms/contact-us/index.vue'], resolve ),
					meta: {
						breadcrumb: 'Contact Us'
					}
				},
				{
					path: 'pricing-popup',
					component: resolve => require ( ['./../admin-views/cms/pricing-popup/index.vue'], resolve ),
					meta: {
						breadcrumb: 'Our Services Page'
					}
				},
			]
		},
		{
			path: 'checklists',
			component: resolve => require ( ['./../admin-views/checklists/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Checklists'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/checklists/checklists-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
				{
					path: 'new',
					component: resolve => require ( ['./../admin-views/checklists/checklists-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Checklist'
					}
				},
				{
					path: ':checklistID/update',
					component: resolve => require ( ['./../admin-views/checklists/checklists-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Edit Checklist'
					}
				},
				{
					path: ':checklistID/view',
					component: resolve => require ( ['./../admin-views/checklists/checklists-view.vue'], resolve ),
					meta: {
						breadcrumb: 'View Checklist'
					}
				}
			]
		},
		{
			path: 'promocodes',
			component: resolve => require ( ['./../admin-views/promocodes/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Promo Codes'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/promocodes/promocodes-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
				{
					path: 'new',
					component: resolve => require ( ['./../admin-views/promocodes/promocodes-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Promo Code'
					}
				},
				{
					path: ':promoCodeID/update',
					component: resolve => require ( ['./../admin-views/promocodes/promocodes-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Edit Promo Code'
					}
				},
				{
					path: ':promoCodeID/view',
					component: resolve => require ( ['./../admin-views/promocodes/promocodes-view.vue'], resolve ),
					meta: {
						breadcrumb: 'View Promo Code'
					}
				}
			]
		},
		{
			path: 'jobs',
			component: resolve => require ( ['./../admin-views/jobs/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Jobs'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/jobs/jobs-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
				{
					path: 'new',
					component: resolve => require ( ['./../admin-views/jobs/jobs-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Job'
					}
				},
				{
					path: ':jobID/update',
					component: resolve => require ( ['./../admin-views/jobs/jobs-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Edit Job'
					}
				},
				{
					path: ':jobID/view',
					component: resolve => require ( ['./../admin-views/jobs/jobs-view.vue'], resolve ),
					meta: {
						breadcrumb: 'View Job'
					}
				}
			]
		},
		{
			path: 'transactions',
			component: resolve => require ( ['./../admin-views/transactions/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Admins'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/transactions/transactions-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
				{
					path: 'new',
					component: resolve => require ( ['./../admin-views/transactions/transactions-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Transaction'
					}
				},
				{
					path: ':transactionID/update',
					component: resolve => require ( ['./../admin-views/transactions/transactions-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Edit Transaction'
					}
				},
				{
					path: ':transactionID/view',
					component: resolve => require ( ['./../admin-views/transactions/transactions-view.vue'], resolve ),
					meta: {
						breadcrumb: 'View Transaction'
					}
				}
			]
		},
		{
			path: 'statistics',
			component: resolve => require ( ['./../admin-views/statistics/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Statistics'
			},
		},
		{
			path: 'admins',
			component: resolve => require ( ['./../admin-views/admins/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Admins'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/admins/admins-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
				{
					path: 'new',
					component: resolve => require ( ['./../admin-views/admins/admins-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Admin'
					}
				},
				{
					path: ':adminID/update',
					component: resolve => require ( ['./../admin-views/admins/admins-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Edit Admin'
					}
				},
				{
					path: ':adminID/view',
					component: resolve => require ( ['./../admin-views/admins/admins-view.vue'], resolve ),
					meta: {
						breadcrumb: 'View Admin'
					}
				}
			]
		},
		// {
		// 	path: 'comment',
		// 	component: resolve => require ( ['./../admin-views/cms/testimonial/index.vue'], resolve ),
		// 	meta: {
		// 		breadcrumb: 'Admins'
		// 	},
		// 	children: [
		// 		{
		// 			path: '',
		// 			component: resolve => require ( ['./../admin-views/cms/testimonial/admins-list.vue'], resolve ),
		// 			meta: {
		// 				breadcrumb: 'Home'
		// 			}
		// 		},
		// 		{
		// 			path: 'new',
		// 			component: resolve => require ( ['./../admin-views/cms/testimonial/admins-form.vue'], resolve ),
		// 			meta: {
		// 				breadcrumb: 'New Admin'
		// 			}
		// 		},
		// 		{
		// 			path: ':adminID/update',
		// 			component: resolve => require ( ['./../admin-views/cms/testimonial/admins-form.vue'], resolve ),
		// 			meta: {
		// 				breadcrumb: 'Edit Admin'
		// 			}
		// 		},
		// 		{
		// 			path: ':adminID/view',
		// 			component: resolve => require ( ['./../admin-views/cms/testimonial/admins-view.vue'], resolve ),
		// 			meta: {
		// 				breadcrumb: 'View Admin'
		// 			}
		// 		}
		// 	]
		// },
		{
			path: 'settings',
			component: resolve => require ( ['./../admin-views/settings/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Settings'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/settings/settings-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
				{
					path: 'new',
					component: resolve => require ( ['./../admin-views/settings/settings-form.vue'], resolve ),
					meta: {
						breadcrumb: 'New Settings'
					}
				},
				{
					path: ':adminID/update',
					component: resolve => require ( ['./../admin-views/settings/settings-form.vue'], resolve ),
					meta: {
						breadcrumb: 'Edit Settings'
					}
				},
				{
					path: ':adminID/view',
					component: resolve => require ( ['./../admin-views/settings/settings-view.vue'], resolve ),
					meta: {
						breadcrumb: 'View Settings'
					}
				}
			]
		},
		{
			path: 'credits',
			component: resolve => require ( ['./../admin-views/credits/index.vue'], resolve ),
			meta: {
				breadcrumb: 'Credits'
			},
			children: [
				{
					path: '',
					component: resolve => require ( ['./../admin-views/credits/credits-list.vue'], resolve ),
					meta: {
						breadcrumb: 'Home'
					}
				},
			]
		}

	]
};

export default routes;


// WEBPACK FOOTER //
// ./src/custom/routes/admin-routes.js